import React, { useMemo, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import { getApiErrorMessage } from '../../services/api';

function todayMinus(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export default function ReportRequestForm({
  stores,
  storeExternalId,
  conversationId,
  onReportRequested,
}) {
  const { t } = useLanguage();
  const [from, setFrom] = useState(todayMinus(1));
  const [to, setTo] = useState(todayMinus(1));
  const [storeId, setStoreId] = useState(storeExternalId || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const storeOptions = useMemo(
    () => [{ value: '', label: t('chatApp.dailyAllStores') }, ...(Array.isArray(stores) ? stores : []).map((s) => ({
      value: s.store_id || '',
      label: s.name || s.store_id,
    }))],
    [stores, t],
  );

  const submit = async (weekly = false) => {
    if (!onReportRequested) return;
    setLoading(true);
    setError('');
    try {
      await onReportRequested({
        weekly,
        from,
        to,
        storeId,
        conversationId,
      });
    } catch (e) {
      setError(getApiErrorMessage(e, t('chatApp.aiError')));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chat-report-request-form">
      <div className="chat-app-toolbar-dates">
        <div className="chat-app-toolbar-field">
          <label className="chat-app-field-label">{t('chatApp.periodFrom')}</label>
          <Form.Control type="date" size="sm" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div className="chat-app-toolbar-field">
          <label className="chat-app-field-label">{t('chatApp.periodTo')}</label>
          <Form.Control type="date" size="sm" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
        <div className="chat-app-toolbar-field chat-app-toolbar-field--store">
          <label className="chat-app-field-label">{t('chatApp.store')}</label>
          <Form.Select size="sm" value={storeId} onChange={(e) => setStoreId(e.target.value)}>
            {storeOptions.map((opt) => (
              <option key={opt.value || 'all'} value={opt.value}>{opt.label}</option>
            ))}
          </Form.Select>
        </div>
        <div className="chat-app-toolbar-actions">
          <Button size="sm" className="btn-gradient" disabled={loading} onClick={() => submit(false)}>
            {loading ? <Spinner size="sm" animation="border" /> : t('chatApp.reportDaily')}
          </Button>
          <Button size="sm" variant="outline-secondary" disabled={loading} onClick={() => submit(true)}>
            {t('chatApp.reportWeekly')}
          </Button>
        </div>
      </div>
      {error && <p className="small text-danger mb-0 mt-1">{error}</p>}
    </div>
  );
}
